import { render, staticRenderFns } from "./doceration.vue?vue&type=template&id=cfbd4954&scoped=true&"
import script from "./doceration.vue?vue&type=script&lang=js&"
export * from "./doceration.vue?vue&type=script&lang=js&"
import style0 from "./doceration.vue?vue&type=style&index=0&id=cfbd4954&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbd4954",
  null
  
)

export default component.exports